import type { JSONContent } from '@tiptap/react';

// insertContentAt parses a bare string as HTML, so wrap as explicit nodes instead — avoids both
// misparsing text like "<100" as a tag and losing "\n" to contenteditable's whitespace handling.
export function toInlineTextContent(text: string): JSONContent[] {
  return text
    .split('\n')
    .flatMap((line, index) => [
      ...(index === 0 ? [] : [{ type: 'hardBreak' }]),
      ...(line ? [{ type: 'text', text: line }] : []),
    ]);
}
